import { Pipe, PipeTransform } from '@angular/core';
import { EmploymentHistory } from '../models/users/dto/employment-history';
import { EmploymentHistoryUtils } from '../utils/employment-history-utils';

@Pipe({
  name: 'isCurrentEmployment',
  standalone: true
})
export class IsCurrentEmploymentPipe implements PipeTransform {
  transform(employment: EmploymentHistory): boolean {
    return EmploymentHistoryUtils.isCurrentEmployment(employment.employmentStatusId, employment.endDate);
  }
}
